import { Injectable } from '@angular/core';
import moment from 'moment';
import { ServiceaftaleDto } from '../api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceaftaleStateEnum } from '../api/models/OK/Egis/Service/Models/Entities/Enums/serviceaftale-state-enum';

@Injectable({
  providedIn: 'root'
})
export class ServiceAgreementStateService {

  constructor() { }

  isServiceaftaleTerminatedOrPendingTermination(serviceaftale:ServiceaftaleDto) {
    return (
      serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.Terminated ||
      serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.ActivePendingTermination
    );
  }

  canServiceaftaleBeReactivated(serviceaftale:ServiceaftaleDto) {
    return (
      (this.isServiceaftaleTerminatedOrPendingTermination(serviceaftale) || serviceaftale.endDate != null) &&
      !serviceaftale.slutopgoerelse?.isCompleted === true &&
      !serviceaftale.anonymiseret &&
      (moment.duration(moment().diff(moment(new Date(serviceaftale.endDate)))).asDays() < 7)
    );
  }  
}
